import { IBulkHandoverDto, IBulkHandoverDtoPersistence } from '../interfaces';

export class BulkHandoverMapper {
  public static toPersistence(dto: IBulkHandoverDto): IBulkHandoverDtoPersistence {
    return {
      state_id: dto.stateId,
      tariff_category_id: dto.tariffCategoryId,
    };
  }
}
